import z from 'zod'
import { decimalSchema } from '../../utils/schema'

const withdrawalHistoryRowSchema = z.object({
  /** トランザクションID。出金失敗やキャンセル時は空文字 */
  txID: z.string(),
  /** 通貨 */
  coin: z.string(),
  /** チェーン名 */
  chain: z.string(),
  /** 出金額 */
  amount: decimalSchema,
  /** 出金手数料 */
  withdrawFee: decimalSchema,
  /** 出金ステータス */
  status: z.string(),
  /** 出金先アドレス（内部転送時はBybit UIDを表示） */
  toAddress: z.string(),
  /** タグ（該当する場合） */
  tag: z.string(),
  /** 出金作成タイムスタンプ（ミリ秒） */
  createTime: z.string(),
  /** 出金更新タイムスタンプ（ミリ秒） */
  updateTime: z.string(),
  /** 出金ID */
  withdrawId: z.string(),
  /** 出金タイプ。0:オンチェーン、1:オフチェーン */
  withdrawType: z.number().int(),
  /** 手数料（詳細不明） */
  fee: decimalSchema.optional(),
  /** 税金（詳細不明） */
  tax: decimalSchema.optional(),
  /** 税率（詳細不明） */
  taxRate: decimalSchema.optional(),
  /** 税タイプ（詳細不明） */
  taxType: z.string().optional(),
})

export const responseSchema = z.object({
  /** レスポンスコード。0 は成功 */
  retCode: z.number(),
  /** レスポンスメッセージ */
  retMsg: z.string(),
  result: z.object({
    /** 出金履歴の配列 */
    rows: z.array(withdrawalHistoryRowSchema),
    /** ページネーション用カーソル */
    nextPageCursor: z.string().nullable(),
  }),
})
